import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { apiService } from '../../api-base'
import { InformationPagePayload, InformationTypes } from './types'
import { FormDataInformationPage } from '~/entities/information/types'

export interface ApiResponse<T> {
  status: boolean
  data: T
}

export class InformationServices {
  static getInformationPage(
    config: AxiosRequestConfig,
  ): Promise<AxiosResponse<InformationTypes[]>> {
    return apiService.get<AxiosResponse<InformationTypes[]>>(
      '/information',
      config,
    )
  }

  static getInformationPageById(
    id: string,
  ): Promise<ApiResponse<FormDataInformationPage>> {
    return apiService.get<ApiResponse<FormDataInformationPage>>(
      `/information/${id}`,
    )
  }

  static createInformationPage(
    data: InformationPagePayload,
  ): Promise<AxiosResponse> {
    return apiService.post<AxiosResponse>('/information', data)
  }

  static updateInformationPage = (id: string, data: InformationPagePayload) => {
    return apiService.put<AxiosResponse<InformationTypes>>(
      `/information/${id}`,
      data,
    )
  }

  static removeInformationPage(id: string) {
    return apiService.delete(`/information/${id}`)
  }
}
